import { useTranslations } from 'next-intl';
import { Skeleton } from './Skeleton';

interface LoadingStateProps {
  variant?: 'default' | 'compact';
  message?: string;
}

/*
 * Whole-page or region wait: a skeleton card (default) or one inline line (compact). The message
 * prop, or Common.loading, is announced once through Skeleton.Group; role="status" stays on the
 * wrapper because callers and tests query it.
 */
export default function LoadingState({ variant = 'default', message }: LoadingStateProps) {
  const t = useTranslations('Common');
  const loadingMessage = message || t('loading');

  if (variant === 'compact') {
    return (
      <div role="status">
        <Skeleton.Group label={loadingMessage} className="flex items-center justify-center py-4">
          <Skeleton.Line width="40%" />
        </Skeleton.Group>
      </div>
    );
  }

  return (
    <div role="status">
      <Skeleton.Group label={loadingMessage}>
        <Skeleton.Card lines={3} />
      </Skeleton.Group>
    </div>
  );
}
